import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

import { ContactlessOutlined, SwipeSharp } from '@mui/icons-material';
import SwiperCore, { Pagination } from 'swiper';
import ConnUrls from '../Connections/ConnectURL';
import { CurrentPContext, MasterContext } from '../ContextApi/context';

SwiperCore.use([Pagination]);


const PopUpsSlides = (props) => {
  const [master, setMaster] = useContext(MasterContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);

  const [timgs, setTimgs] = useState(props.TopImages);

  useEffect(() => {
  }, []);




  return (
    <div className={"specialPopsImages"}>
      <Swiper
        loop={true}
        freeMode={false}
        className={"specialPopsSwiper"}
        spaceBetween={0}
        slidesPerView={1}
        pagination={true}
      >
        {
          timgs.map((item, index) => {
            return (
              <SwiperSlide key={index} className={"specialPops"}>

                {/* <Link to={`/cat/${item._id}`}> */}
                <div className={"spopImgWrap"}>
                  <img className={"spopImage"} src={`${ConnUrls.servMediasUrl}${item.img}`} alt={currentPage.altTags || currentPage.pageName || ""} />
                  <div className={"spopimgTxt bold big pointing"} >
                    {parse(`${item.txt}`)}
                  </div>

                </div>
                {/* </Link> */}
              </SwiperSlide>
            )

          })
        }

      </Swiper>

    </div>
  )

}

export default PopUpsSlides;



